const state = {
    challenges: []
}

const mutations = {
    SET_CHALLENGES (state, value) {
        state.challenges = value
    },
}

const actions = {
    setChallenges ({commit}, value) {
        commit('SET_CHALLENGES', value)
    },
}

const getters = {
    challenges: state => {
        return state.challenges
    }
}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
}
